import {
  GroupRestrictions,
  RestrictionItem,
} from 'src/common/OrderRestrictions/orderRestrictions.utils';
import {
  FieldsResponse,
  Markets,
  OriginatingBrands,
  Terms,
  EmployeeFundedPlan,
} from 'src/types/CorporateFieldsData';
import { transformPenniesToDollar } from 'src/utilities/currency-utils';

type MarketItem = {
  value: string;
  text: string;
};

type MarketList = MarketItem[];

type TermItem = {
  value: string;
  text: string;
};

type TermList = TermItem[];

type MembershipOption = {
  value: string;
  text: string;
};

type MembershipOptionList = MembershipOption[];

export type TransformedCorporateFields = {
  markets: MarketList;
  originatingBrands?: OriginatingBrands;
  terms: TermList;
  employeeFundedPlans?: MembershipOptionList;
  dinerNotificationPreferences: GroupRestrictions;
};

const transformMarketsModelToUI = (markets: Markets): MarketList => {
  const marketsList = Object.entries(markets).map(([key, value]) => ({
    value: key,
    text: value,
  }));

  marketsList.sort((a, b) => a.text.localeCompare(b.text));

  return marketsList;
};

const transformTermsModelToUI = (terms: Terms): TermList => {
  return terms.map((term) => ({
    value: term,
    text: term,
  }));
};

// GH Plus employee-funded plan prices for the corp form screen dropdown.
// Trial length is included in the value due to the lack of a separate field.
const transformPlanToOptions = (
  employeeFundedPlans: EmployeeFundedPlan[]
): MembershipOptionList => {
  return employeeFundedPlans.map((plan) => ({
    value: `${plan.price}-${plan.trialLengthDays}`,
    text: `$${transformPenniesToDollar(plan.price)}/month`,
  }));
};

export const transformDinerNotificationPreferencesToUI = (
  preferences: RestrictionItem[]
): GroupRestrictions => [
  {
    categoryName: '',
    restrictions: preferences,
  },
];

export const transformFieldsDataModelToUI = (
  data: FieldsResponse
): TransformedCorporateFields => {
  return {
    ...data,
    markets: transformMarketsModelToUI(data.markets),
    terms: transformTermsModelToUI(data.terms),
    employeeFundedPlans: transformPlanToOptions(data.employeeFundedPlans),
    dinerNotificationPreferences: transformDinerNotificationPreferencesToUI(
      data.dinerNotificationPreferences
    ),
  };
};
